module.exports = __webpack_public_path__ + "static/media/image_part_012.cd6d9dc6.jpg";